import { useUserEventLogger } from '@repo/tracking-service';
import { Chip } from '@repo/ui';

import { FAQ_CATEGORIES } from '@/lib/constants/help';

export const CategoryFilter = ({ selectedCategory, setSelectedCategory }: { selectedCategory: string; setSelectedCategory: (category: string) => void }) => {
  const { sendClickEvent } = useUserEventLogger();

  const selectCategory = (category: string) => {
    sendClickEvent(`faq_body_chip-${category}`);
    setSelectedCategory(category);
  };

  return (
    <div className={'flex flex-wrap gap-1.5 break-all'}>
      {Array.from(FAQ_CATEGORIES.keys()).map((categoryKey) => (
        <Chip
          key={categoryKey}
          isSelected={selectedCategory === categoryKey}
          onClick={() => selectCategory(categoryKey)}
          label={FAQ_CATEGORIES.get(categoryKey) || ''}
        />
      ))}
    </div>
  );
};
